import _ from 'lodash';
import { AD_TYPE } from 'src/const/state/creative';
import { INVENTORY_FLOW } from 'src/const/state/inventory-type';
import { campaignObjectiveValue } from 'src/const/state/campaign';

export const NOT_SUPPORT_INSTANT_EXPERIENCE_THIS_INVENTORY_FLOW = {
  NOT_SUPPORT_INSTANT_PAGE: {
    value: 1,
    i18nKey: 'module_inventory_flow_not_support_instant_page_hint_in_preview',
  },
  NOT_SUPPORT_COLLECTION_ADS: {
    value: 2,
    i18nKey: 'module_inventory_flow_not_support_collection_ads_hint_in_preview',
  },
};

const { SINGLE_VIDEO, CATALOGUE_VIDEO } = AD_TYPE;
const {
  AppInstall,
  Conversion,
  Traffic,
  Reach,
  VideoView,
  RF,
  RF_VV,
  RF_ENGAGEMENT,
  RF_TRAFFIC,
  RF_APPINSTALL,
  LeadAds,
} = campaignObjectiveValue;

export const customizedAdditionalCreativeObjectiveTypes = [AppInstall, Conversion, Traffic, Reach, VideoView];

const additionalCreativeCustomizedImageCardEnableInfo = {
  objectiveType: [AppInstall, Conversion, Traffic, LeadAds, RF, RF_VV, RF_ENGAGEMENT, RF_APPINSTALL, RF_TRAFFIC],
  inventoryFlow: [INVENTORY_FLOW.TIKTOK],
  adTypes: [SINGLE_VIDEO.value],
};
const additionalCreativeGameGiftCardEnableInfo = {
  objectiveType: [AppInstall, Conversion, Traffic, RF, RF_VV, RF_ENGAGEMENT, RF_APPINSTALL, RF_TRAFFIC],
  inventoryFlow: [INVENTORY_FLOW.TIKTOK],
  adTypes: [SINGLE_VIDEO.value],
};
// 普通instantPage
export const normalAdditionalInstantPageEnableInfo = {
  objectiveType: [Conversion, Traffic, RF_TRAFFIC],
  inventoryFlow: [INVENTORY_FLOW.TIKTOK],
  adTypes: [SINGLE_VIDEO.value],
};
// appProfile InstantPage
export const additionalAppProfileInstantPageEnableInfo = {
  objectiveType: [AppInstall],
  inventoryFlow: [INVENTORY_FLOW.TIKTOK],
  adTypes: [SINGLE_VIDEO.value],
};

export const additionalInstantPageEnableInfo = {
  objectiveType: [...new Set([...normalAdditionalInstantPageEnableInfo.objectiveType, ...additionalAppProfileInstantPageEnableInfo.objectiveType])],
  inventoryFlow: [...new Set([...normalAdditionalInstantPageEnableInfo.inventoryFlow, ...additionalAppProfileInstantPageEnableInfo.inventoryFlow])],
  adTypes: [...new Set([...normalAdditionalInstantPageEnableInfo.adTypes, ...additionalAppProfileInstantPageEnableInfo.adTypes])],
};

export const getIsCustomizedImageCardEnable = ({
  objectiveType, inventoryFlow, isUserEnable, adType,
}) => {
  const isObjectTypeEnable = additionalCreativeCustomizedImageCardEnableInfo.objectiveType.includes(objectiveType);
  const EnableInventoryFlowList = additionalCreativeCustomizedImageCardEnableInfo.inventoryFlow;
  const isInventoryFlowEnable = _.intersection(EnableInventoryFlowList, inventoryFlow).length;
  const isAdTypeAllowed = additionalCreativeCustomizedImageCardEnableInfo.adTypes.includes(+adType);
  return isObjectTypeEnable
    && isInventoryFlowEnable
    && isAdTypeAllowed
    && isUserEnable;
};

export const getIsGameGiftCardEnable = ({
  objectiveType, inventoryFlow, isUserEnable, adType,
}) => {
  const isObjectTypeEnable = additionalCreativeGameGiftCardEnableInfo.objectiveType.includes(objectiveType);
  const EnableInventoryFlowList = additionalCreativeGameGiftCardEnableInfo.inventoryFlow;
  const isInventoryFlowEnable = _.intersection(EnableInventoryFlowList, inventoryFlow).length;
  const isAdTypeAllowed = additionalCreativeGameGiftCardEnableInfo.adTypes.includes(+adType);
  return isObjectTypeEnable
    && isInventoryFlowEnable
    && isAdTypeAllowed
    && isUserEnable;
};
// AppProfile InstantPage 是否可用
export const getIsAppProfileInstantPageEnable = ({
  objectiveType, inventoryFlow, isUserEnable, adType, isAppProfileInstantPageUserEnable, isIos14Creative, isInstall, isAppProfilePageOpen,
}) => {
  const isObjectTypeEnable = additionalAppProfileInstantPageEnableInfo.objectiveType.includes(objectiveType);
  const EnableInventoryFlowList = additionalAppProfileInstantPageEnableInfo.inventoryFlow;
  const isInventoryFlowEnable = _.intersection(EnableInventoryFlowList, inventoryFlow).length;
  const isAdTypeAllowed = additionalAppProfileInstantPageEnableInfo.adTypes.includes(+adType);
  return isObjectTypeEnable
    && isInventoryFlowEnable
    && isAdTypeAllowed
    && (isUserEnable || isAppProfileInstantPageUserEnable)
    && isIos14Creative
    && isAppProfilePageOpen
    && isInstall;
};
// 普通InstantPage是否可用
export const getIsCustomInstantPageEnable = ({
  objectiveType, inventoryFlow, isUserEnable, adType, isAppDownload, isNormalInstantPageUserEnable,
}) => {
  const isObjectTypeEnable = normalAdditionalInstantPageEnableInfo.objectiveType.includes(objectiveType);
  const EnableInventoryFlowList = normalAdditionalInstantPageEnableInfo.inventoryFlow;
  const isInventoryFlowEnable = _.intersection(EnableInventoryFlowList, inventoryFlow).length;
  const isAdTypeAllowed = normalAdditionalInstantPageEnableInfo.adTypes.includes(+adType);
  const isPromotionTypeAllowed = !isAppDownload;
  return isObjectTypeEnable
    && isInventoryFlowEnable
    && isAdTypeAllowed
    && isPromotionTypeAllowed
    && (isUserEnable || isNormalInstantPageUserEnable);
};

export const getIsInstantPageEnable = params => getIsCustomInstantPageEnable(params)
    || getIsAppProfileInstantPageEnable(params);

/**
 * 支持 Collection Ads 的创意的条件配置
 */
export const COLLECTION_ADS_ENABLE_CONFIG = {
  inventoryFlow: [INVENTORY_FLOW.TIKTOK],
  adTypes: [SINGLE_VIDEO.value, CATALOGUE_VIDEO.value],
};
